import React, { useEffect } from "react";
import {
  Card,
  CardHeader,
  Input,
  Container,
  Button,
  Table,
  Row,
} from "reactstrap";
import { useState } from "react";
// import "views/pages/manage/addressType/node_modules/react-sliding-pane/dist/react-sliding-pane.css";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";
import {
  MasterHeaderAuto,
} from "../../common/commonComponents/masterHeader/masterHeader";
import { NewRow }  from "../../common/utils/methods/commonMethods/utilityMethod";
import {
  getAPI,
  masterServiceBaseUrl,
  successToast,
  putpost,
  putpost2,
} from "services/http";
import moment from "moment";
var _ = require("lodash");

const DayMasterTable = (props) => {
  const {
    serverData,
    setSearch,
    resetSearch,
    isSaveVisible,
    setisSaveVisible,
    action,
  } = props;
  const [tableDataKey, settableDataKey] = useState("tableDataKey");
  const [updatedKey, setUpdateKey] = useState(new Date());
  const [searchStr, setSearchStr] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const addNewClass = () => {
    props.setclassArray([
      {
        editMode: true,
        __status: "__new",
        status: "ACTIVE",
        dayMasterDesc: null,
        dayMasterKey: null,
        dayMasterDispValue: null,
        updatedDate: null,
      },
      ...props.classArray,
    ]);
  };

  const headerList = [
    { name: "Key" },
    { name: "Description" },
    { name: "Display Value" },
    { name: "Effective Date" },
    { name: "Status" },
    { name: "Action" },
  ];

  const listToRender = [
    "dayMasterKey",
    "dayMasterDesc",
    "dayMasterDispValue",
    "effectiveDate",
    "status",
  ];

  const saveAll = (cb) => {
    var _tempArray = props.classArray;
    var isValid = true;
    _tempArray.forEach((el, index) => {
      if (el["editMode"]) {
        if (!el["dayMasterKey"] || !el["dayMasterKey"].trim()) {
          isValid = false;
          failureToast("Please Enter Key");
          return;
        }else if (!el["dayMasterDesc"] || !el["dayMasterDesc"].trim()) {
          isValid = false;
          failureToast("Please Enter Description");
          return;
        }
        // else if (
        //   !el['dayMasterShortDesc'] ||
        //   !el['dayMasterShortDesc'].trim()
        // ) {
        //   isValid = false;
        //   failureToast('Please Enter Short Description');
        //   return;
        // }
        else if (
          !el["dayMasterDispValue"] ||
          !el["dayMasterDispValue"].trim()
        ) {
          isValid = false;
          failureToast("Please Enter Display Value");
          return;
        }
        if (!isValid) {
          return;
        }
        if (_tempArray[index]["__status"] == "__new") {
          putpost(
            masterServiceBaseUrl + "/dayMaster/createDayMaster",
            (data) => {
              successToast(data["message"]);
              setisSaveVisible(false);
              setUpdateKey(new Date());
              props.fetchClasses(
                `${masterServiceBaseUrl}/dayMaster/getAllDayMaster`
              );
            },
            (data) => {
              failureToast(data["message"]);
            },
            _tempArray[index],
            "post"
          );
        } else {
          putpost(
            masterServiceBaseUrl +
              "/dayMaster/updateDayMaster/" +
              _tempArray[index].id,
            (data) => {
              successToast(data["message"]);
              setisSaveVisible(false);
              // delete _tempArray[index]['editMode']
              // props.setclassArray(_tempArray)
              props.fetchClasses(
                `${masterServiceBaseUrl}/dayMaster/getAllDayMaster`
              );
              settableDataKey(new Date().getMilliseconds());
              // props.fetchClasses(masterServiceBaseUrl + '/class/getAllClass')
            },
            (data) => {
              failureToast(data["message"]);
            },
            _tempArray[index],
            "put"
          );
        }
      } else {
      }
    });
  };
  const newRow = () => {
    if (isSaveVisible) {
      failureToast("Please Delete or Save current changes");
    } else {
      let cb = () => {
        addNewClass();
        setisSaveVisible(true);
        // settableDataKey(new Date().getMilliseconds())
      };
      var _tempArray = props.classArray;
      _tempArray = _.sortBy(_tempArray, [
        function (o) {
          return o.value;
        },
      ]);
      props.setclassArray(_tempArray);
      setisSaveVisible(false);
      cb();
    }
  };
  const editRow = (index) => {
    if (isSaveVisible) {
      failureToast("Please Delete or Save current changes");
    } else {
      let cb = () => {
        var _tempArray = props.classArray;
        _tempArray[index]["editMode"] = true;
        props.setclassArray(_tempArray);
        setisSaveVisible(true);
      };
      var _tempArray = props.classArray;
      _tempArray = _.sortBy(_tempArray, [
        function (o) {
          return o.value;
        },
      ]);
      cb();
    }
  };
  const deleteRow = (index) => {
    if (props.classArray[index]["__status"] == "__new") {
      let n = props.classArray;
      n.splice(index, 1);
      props.setclassArray(n);
      setisSaveVisible(false);
      settableDataKey(new Date().getMilliseconds());
    } else {
      if (
        window.confirm("Are you sure you want to delete this Day ?")
      ) {
        putpost2(
          masterServiceBaseUrl +
            "/dayMaster/deleteDayMaster/" +
            props.classArray[index].id,
          (data) => {
            successToast(data["message"]);
            if (props.classArray.length == 1) {
              props.previousPage();
              props.fetchClasses(
                `${masterServiceBaseUrl}/dayMaster/getAllDayMaster`
              );
            } else {
              var _tempArray = props.classArray;
              if (_tempArray[index]["editMode"]) {
                setisSaveVisible(false);
              }
              _tempArray.splice(index, 1);
              props.setclassArray(_tempArray);
            }
            settableDataKey(new Date().getMilliseconds());
          },
          (data) => {
            failureToast(data["message"]);
          },
          "PUT"
        );
      }
    }
  };

  const updateKey = (index, value, key) => {
    var _tempArray = props.classArray;
    _tempArray[index][key] = value;
    props.setclassArray(_tempArray);
    setUpdateKey(new Date());
  };

  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3 className="mb-0 ">Master - Day</h3>
 
                <Button
                  disabled={isSaveVisible || isDisabled}
                  color="info"
                  size="sm"
                  type="button"
                  className={
                    "floatRight" +
                    (isSaveVisible || isDisabled ? " btn-dark" : null)
                  }
                  onClick={() => {
                    newRow();
                  }}
                  data-testid="addNewDayMaster"
                >
                  New Day
                </Button>
              </CardHeader>
              <div id="questionTable" className="table-responsive">
                <Table className="align-items-center table-flush tableLayout">
                  <MasterHeaderAuto headerList={headerList} />
                  <tbody className="list" key={tableDataKey}>
                    {props.classArray
                      ? props.classArray.map((el, index) =>
                          !el["editMode"] ? (
                            //
                            <>
                              <NewRow data={el} listToBeRendered={listToRender}>
                                <td className="text-center  white-breakSpace">
                                  <Button
                                    color="info"
                                    size="sm"
                                    type="button"
                                    disabled={props.isViewOnly}
                                    onClick={() => editRow(index)}
                                    // data-testid="editButton"
                                  >
                                    <i className="fas fa-edit" />
                                  </Button>
                                
                                </td>
                              </NewRow>
                            </>
                          ) : (
                            <tr key={index + "-class"}>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  data-testid="dayMasterKey"
                                  placeholder="Key"
                                  maxLength="50"
                                  className="tdInput"
                                  defaultValue={el["dayMasterKey"]}
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value,
                                      "dayMasterKey",
                                      true
                                    );
                                  }}
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  maxLength="50"
                                  defaultValue={el["dayMasterDesc"]}
                                  data-testid="dayMasterDesc"
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value,
                                      "dayMasterDesc",
                                      true
                                    );
                                  }}
                                  placeholder="Description"
                                  className="tdInput"
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  maxLength="50"
                                  defaultValue={el["dayMasterDispValue"]}
                                  data-testid="dayMasterDispValue"
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value,
                                      "dayMasterDispValue",
                                      true
                                    );
                                  }}
                                  placeholder="Display value"
                                  className="tdInput"
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  placeholder="Updated date"
                                  disabled
                                  className="tdInput"
                                  data-testid="updatedOn"
                                  defaultValue={moment(el["updatedOn"]).format(
                                    "DD-MM-YYYY"
                                  )}
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <label className="custom-toggle mx-auto ml-2">
                                  <input
                                    checked={
                                      el.status == "ACTIVE" ? true : false
                                    }
                                    type="checkbox"
                                    id={el.id}
                                    onChange={(e) => {
                                      settableDataKey(
                                        new Date().getMilliseconds()
                                      );
                                      let n = "ACTIVE";
                                      if (!e.target.checked) {
                                        n = "INACTIVE";
                                      }
                                      updateKey(index, n, "status");
                                    }}
                                    data-testid="dayMasterStatus"
                                  />
                                  <span
                                    style={{ width: "72px" }}
                                    className="custom-toggle-slider rounded-circle activeToggle"
                                    data-label-off="Inactive"
                                    data-label-on="Active"
                                  />
                                </label>
                              </td>
                              <td
                                className="text-center"
                                data-testid="saveConcessionDayMaster"
                              >
                                {isSaveVisible ? (
                                  <>
                                    {" "}
                                    <Button
                                      color="info"
                                      size="sm"
                                      type="button"
                                      className="mx-1"
                                      onClick={() => {
                                        saveAll();
                                      }}
                                    >
                                      Save
                                    </Button>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      type="button"
                                      onClick={() => {
                                        let n = props.classArray;
                                        if (n[index]["__status"] == "__new") {
                                          n.splice(index, 1);
                                        } else {
                                          // n[index]['editMode'] = false
                                          props.fetchClasses(
                                            `${masterServiceBaseUrl}/dayMaster/getAllDayMaster`
                                          );
                                        }
                                        props.setclassArray(n);
                                        setisSaveVisible(false);
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-times" />
                                    </Button>{" "}
                                  </>
                                ) : (
                                  <Button
                                    color="info"
                                    size="sm"
                                    type="button"
                                    onClick={() => {
                                      deleteRow(index);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-trash" />
                                  </Button>
                                )}
                              </td>
                            </tr>
                          )
                        )
                      : null}
                  </tbody>
                </Table>
              </div>
             
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
export default DayMasterTable;
